import { enqueueNotification, SnackbarItem } from '@core/features/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { heroApiService } from '@services/.';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { LocationReducerProps } from '../type';
import { RootState } from '@core/configureStore';
import { fetchCurrentUser } from '@core/features/auth/thunks';
import { LocalLocation } from '@core/models';

export const updateGeneralInfo = createAsyncThunk(
  'business/updateGeneralInfo',
  async (partialLocationPayload: Partial<LocalLocation>, thunkApi) => {
    try {
      const {
        auth: { user },
      } = thunkApi.getState() as RootState;
      if (!user) throw new Error('No user found');
      const selectedLocation = user.selected_location;

      await heroApiService.updateLocation(selectedLocation.location_id, partialLocationPayload);
      await thunkApi.dispatch(fetchCurrentUser());
      thunkApi.dispatch(
        enqueueNotification({
          name: `Update general info of location ${selectedLocation.title}`,
          description: 'Successfully updated business',
          type: 'Success',
        } as SnackbarItem)
      );
    } catch (error: any) {
      thunkApi.dispatch(
        enqueueNotification({
          name: 'Failed to update business',
          type: 'Error',
        } as SnackbarItem)
      );
      throw new Error(error);
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(updateGeneralInfo);

export const updateGeneralInfoReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<LocationReducerProps>;
